import React from "react";

const fixedCost = 0.05 + 0.10 + 0.10; // Water, electricity, cleaning

const coffeeRecipes = {
  "Espresso": { "Espresso": 13 },
  "Cafe Latte": { "Espresso": 13, "Milk": 140 },
  "Capuccino": { "Espresso": 13, "Milk": 120 },
  "Spanish Latte": { "Espresso": 13, "Milk": 120, "Condensed Milk": 38 },
  "Mocha Latte": { "Espresso": 13, "Milk": 120, "Cacao": 10, "Dark sauce": 15 },
  "Nutella Latte": { "Espresso": 13, "Nutella": 20, "Milk": 120 },
  "Kinder White Latte": { "Espresso": 13, "Kinder white": 20, "Milk": 120 },
  "Kinder White Frappe": { "Espresso": 13, "Kinder white": 20, "Milk": 120 },
  "Nutella Frappe": { "Espresso": 13, "Nutella": 20, "Milk": 120 },
  "Mocha Frappe": { "Espresso": 13, "Milk": 120, "Cacao": 10, "Dark sauce": 15 },
  "Spanish Frappe": { "Espresso": 13, "Milk": 120, "Condensed Milk": 38 },
  "Cafe Frappe": { "Espresso": 13, "Milk": 140 },
  "Oreo Milkshake": { "Oreo Hersheys": 60, "Milk": 400 },
  "Strawberry Milkshake": { "Yan Yan Fraise": 60, "Milk": 400},
  "Kinder Milkshake": { "Kinder white": 60, "Milk": 400},
  "Pistachio Milkshake": { "Pistachio Italian": 60, "Milk": 400},
  "Lotus Milkshake": { "Lotus Biscoff": 60, "Milk": 400},
  "Nutella Milkshake": { "Nutella": 60, "Milk": 400}

};

const getIngredientCost = (name, amountInGrams, menu) => {
  const item = menu.find(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());
  if (!item || typeof item.pricePerKg === "undefined") {
    console.warn(`⚠️ Missing ingredient or price for: ${name}. Ensure it's in Firestore.`);
    return 0;
  }
  return (parseFloat(item.pricePerKg) / 1000) * amountInGrams;
};

export const calculateCoffeeCost = (type, menu) => {
  if (!coffeeRecipes[type]) return 0;
  let cost = fixedCost;
  for (const ingredient in coffeeRecipes[type]) {
    const amount = coffeeRecipes[type][ingredient];
    cost += getIngredientCost(ingredient, amount, menu);
  }
  return cost;
};

const CoffeeCostCalculator = ({ menu }) => {
  return (
    <div className='mt-10 p-6 bg-gray-900 rounded-lg'>
      <h2 className='text-2xl font-bold mb-4'>Coffee Cost Calculator</h2>
      <div className='grid grid-cols-2 gap-4'>
        {Object.keys(coffeeRecipes).map(coffee => (
          <div key={coffee} className='mb-2'>
            <h3>{coffee}: ${calculateCoffeeCost(coffee, menu).toFixed(2)}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoffeeCostCalculator;

